import React from 'react';
import { IonicButton } from 'ionic-ui';
import { useHistory } from 'react-router';

export default function WelcomeMessageDialog({
  onNext,
}: {
  onNext?: () => void;
}) {
  const history = useHistory();

  const startJourney = () => {
    if (onNext) onNext();
    history.replace('/dashboard/get-started');
  };

  return (
    <div className="dialog-content sm:w-80 space-y-6">
      <div className="flex justify-center max-h-40 rounded-md bg-[#d2ebfc]">
        <img
          src="/images/handshake.png"
          alt="Mail Envelope"
          className="max-w-full max-h-[100%]"
        />
      </div>
      <h5 className="mt-4 high-emphasis-text font-bold text-center">
        Welcome to SwiftMedix!
      </h5>
      <p className="medium-emphasis-text mb-4 text-center">
        Your account has been created successfully. You are all set! Explore all
        the features and start your journey with SwiftMedix.
      </p>
      <IonicButton
        size="lg"
        type="button"
        onClick={startJourney}
        className="block w-full"
      >
        Start journey
      </IonicButton>
    </div>
  );
}
